import settings from '@/config/settings';

import type {TId} from '@/assets/core/assets/api/types';
import type {
  IRecipient,
  IRecipientCreate,
  IRecipientFilters,
  IRecipientUpdate,
} from '@/api/types/recipient';
import type {INotificationRoleIdPatch} from '@/api/types/role';

import useAPIHook from '@/assets/core/assets/hooks/APIHook';

import type {IQueryObject} from '@/assets/core/assets/helpers/serialize';

const url = new URL(settings.SERVICES.BASE.URL + '/recipients');

const useRecipientAPIHook = <
  TGetShort,
  TGet,
  TCreate,
  TUpdate,
  TFilters extends IQueryObject = IQueryObject,
>(
  baseUrl: URL,
) => {
  const api = useAPIHook<TGetShort, TGet, TCreate, TUpdate, TFilters>(baseUrl);

  const getMe = async (): Promise<TGet> => await api.getOne('me');

  const patchNotificationRoles = async (
    id: TId,
    payload: INotificationRoleIdPatch,
  ): Promise<TGet> => {
    return await api.request.patch(api.getURLById(id) + '/roles', payload);
  };

  return {
    getMe,
    patchNotificationRoles,
    ...api,
  };
};

export const recipientAPI = useRecipientAPIHook<
  IRecipient,
  IRecipient,
  IRecipientCreate,
  IRecipientUpdate,
  IRecipientFilters
>(url);
